import React from 'react';
import { motion } from 'framer-motion';

const pillars = [
  'Architecture before implementation',
  'Performance as a core requirement',
  'Maintainability through modular design',
];

const PhilosophyV3 = () => {
  return (
    <section className="w-full rounded-2xl bg-white border border-gray-200">
      <div className="max-w-6xl mx-auto px-6 py-24">
        <h2 className="text-4xl font-bold tracking-tight text-gray-900 mb-6">Engineering Philosophy</h2>
        <p className="text-lg text-gray-600 mb-8">
          A backend-first product mindset focused on reliability, scale, and long-term maintainability.
        </p>
        <div className="grid md:grid-cols-3 gap-5">
          {pillars.map((pillar, i) => (
            <motion.div
              key={pillar}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.45, delay: i * 0.08 }}
              viewport={{ once: true }}
              className="rounded-xl bg-gray-50 p-6 shadow-md hover:shadow-lg hover:-translate-y-2 transition-all duration-300"
            >
              <p className="text-gray-800 font-semibold">{pillar}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PhilosophyV3;
